import React, { Component } from "react";
import "../../../assets/css/policy.css";

class MobilePrivacyPolicy extends Component {
    render() {
        return (
            <div className="error-sec">
                <div className="col-md-12 navbarOtr">
                    <nav className="navbar navbar-expand-lg col-md-12">
                        <a className="navbar-brand">
                            <img src="/img/fca-logo.svg" alt="FCA Tracker Logo" />
                        </a>
                    </nav>
                </div>
                <div className="dashboard-outer">
                    <div className="outer-detail" id="outr">
                        <div className="right-panel-section expandnavbarr" id="main">
                            <div className="dtl-sec col-md-12">
                                <div className="tab-dtl region-mng policy">
                                    <div className="tab-active">
                                        <div className="dtl-sec">
                                            <div className="banner">
                                                <h3>Mobile App Privacy Policy</h3>
                                            </div>
                                            <div className="content">
                                                <p className="contents">
                                                    FCA Tracker respects your privacy. This app uses the device camera solely to capture photos or
                                                    videos as part of app functionality. These images or videos are stored locally or uploaded
                                                    securely to our servers for use within the app. We do not share or sell any user data to third
                                                    parties.
                                                </p>
                                                <p className="contents">
                                                    Data collected through the camera is used only for submitting survey responses or attaching
                                                    assets.
                                                </p>
                                                <div className="info mt-4">
                                                    <h3>FCA Tracker, a CBRE partner</h3>
                                                    {/* <div className="phone">
                                                        Phone: <a href="tel:5513023344">(551) 302-3344</a>
                                                    </div> */}
                                                    <div className="email">
                                                        E-mail:&nbsp;
                                                        <a href="mailto:support@fcatarcker.com">support@fcatarcker.com</a>
                                                    </div>
                                                    <div className="update mt-3">
                                                        <p>Last updated: October 24, 2025</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MobilePrivacyPolicy;
